import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The hover controls of an ordinary block. Split out of `web-item-controls`,
 * which dressed every entity on the page and therefore carried each one's
 * exceptions: only a block has the move arrows, the "copy to page" and
 * "save to gallery" entries and the compact "Block" dropdown, and only this
 * kind of block has all three at once.
 */
@Component({
    selector: 'web-default-block-controls',
    templateUrl: './default-block-controls.component.html',
    styleUrls: ['./default-block-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class DefaultBlockControlsComponent {
    /** Reordering stops at the ends of the page and at a pinned or shared neighbour. */
    public readonly disableMoveUp = input<boolean>(false);
    public readonly disableMoveDown = input<boolean>(false);

    /** A block holding the cart widget, or one the plan's product limit locks. */
    public readonly disableCopyEvent = input<boolean>(false);
    public readonly disableRemoveEvent = input<boolean>(false);

    public readonly selectActionTooltip = input<string>('');

    /** Pinned to the top or the bottom of the viewport — see {@link isPinned}. */
    public readonly pinOnTheTop = input<boolean>(false);
    public readonly pinOnTheBottom = input<boolean>(false);

    public readonly copyToPage = input<boolean>(false);
    public readonly saveBlockToGallery = input<boolean>(false);

    public readonly selectEvent = output<void>();
    public readonly copyEvent = output<void>();
    public readonly copyToPageEvent = output<void>();
    public readonly saveBlockToGalleryEvent = output<void>();
    public readonly deleteEvent = output<void>();
    public readonly moveUpEvent = output<void>();
    public readonly moveDownEvent = output<void>();
    public readonly toggleMoreActionState = output<boolean>();

    /**
     * A pinned block sits at a fixed end of the page, so it cannot be reordered:
     * the arrows stay on screen, disabled, with a tooltip saying why.
     */
    public readonly isPinned = computed<boolean>(() => this.pinOnTheTop() || this.pinOnTheBottom());

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public copyAction(): void {
        if (this.disableCopyEvent()) {
            return;
        }

        this.copyEvent.emit();
    }

    public copyToPageAction(): void {
        this.copyToPageEvent.emit();
    }

    public saveBlockToLibraryAction(): void {
        this.saveBlockToGalleryEvent.emit();
    }

    public deleteAction(): void {
        if (this.disableRemoveEvent()) {
            return;
        }

        this.deleteEvent.emit();
    }

    public moveUpAction(): void {
        if (this.disableMoveUp() || this.isPinned()) {
            return;
        }

        this.moveUpEvent.emit();
    }

    public moveDownAction(): void {
        if (this.disableMoveDown() || this.isPinned()) {
            return;
        }

        this.moveDownEvent.emit();
    }

    public isShowDropDownMenu(state: boolean): void {
        this.toggleMoreActionState.emit(state);
    }
}
